import React from "react";

import { Grid, Card, CardContent, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { TextField, DateField, SelectField } from "react-admin";

import { getFormTab } from "../../../utils/utils";
import { AuditStatuses } from "../../../utils/constants";
import OperatorsList from "../../../crewApp/pages/audit/OperatorsList";

const useAsideStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("sm")]: {
      width: "18em",
      minWidth: "18em",
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(0.5),
      overflow: "initial",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  operators: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  item: {
    margin: theme.spacing(0.5),
  },
}));

export const AuditEditAside = ({ record, locations, ...props }) => {
  const classes = useAsideStyles();
  var tab = getFormTab(props);

  if (!record || tab !== "0") return null;
  return (
    <Card className={classes.root}>
      <CardContent>
        <Grid container direction="column" spacing={1}>
          <Grid item xs={12}>
            <Typography variant="overline" color="textSecondary">
              Status:
            </Typography>
            <br />
            <SelectField
              source="status"
              record={record}
              choices={AuditStatuses}
            />
          </Grid>
          {record.accountName && (
            <Grid item xs={12}>
              <Typography variant="overline" color="textSecondary">
                Accounts:
              </Typography>
              <br />
              <TextField source="accountName" record={record} />
            </Grid>
          )}
          <Grid item xs={12}>
            <Typography variant="overline" color="textSecondary">
              Operators:
            </Typography>
            <br />
            <OperatorsList
              currentAudit={record}
              locations={locations}
              classes={classes}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="overline" color="textSecondary">
              Updated At:
            </Typography>
            <br />
            <DateField source="updatedAt" showTime={true} record={record} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
